import $ from 'jquery';

function init() {
  setPagerHeight();
}

function setPagerHeight() {
  const $elms = $('.p-article__pager a');

  if (!$elms[0]) {
    return;
  }

  let elmH = 0;

  $elms.each((i, elm) => {
    const $elm = $(elm);
    const $elmH = $elm.height();

    if (elmH < $elmH) {
      elmH = $elmH;
    }
  });

  $elms.each((j, el) => {
    const $elm = $(el);

    $elm.height(elmH);
  });
}

export default {
  init,
};
